import { createBrowserRouter, type RouteObject } from "react-router-dom";
import { ProtectedRoute } from "../components/auth/ProtectedRoute.js";
import { Leaderboard } from "../components/leaderboard/Leaderboard.js";
import { PaperDashboard } from "../components/dashboard/PaperDashboard.js";
import { LiveDashboard } from "../components/dashboard/LiveDashboard.js";
import { SystemHealth } from "../components/health/SystemHealth.js";
import { AppShell } from "../components/shell/AppShell.js";
import { AISignalsPage } from "../pages/AISignalsPage.js";
import { AlertsPage } from "../pages/AlertsPage.js";
import { DashboardPage } from "../pages/DashboardPage.js";
import { DcaPage } from "../pages/DcaPage.js";
import { ExchangeKeysPage } from "../pages/ExchangeKeysPage.js";
import { MobilePortfolioPage } from "../pages/MobilePortfolioPage.js";
import { PortfolioPage } from "../pages/PortfolioPage.js";
import { ScannerPage } from "../pages/ScannerPage.js";
import { TrainingCenterPage } from "../pages/TrainingCenterPage.js";
import { PlaceholderPage } from "../pages/PlaceholderPage.js";
import { OnboardingPage } from "../pages/auth/OnboardingPage.js";
import { SignInPage } from "../pages/auth/SignInPage.js";
import { SignUpPage } from "../pages/auth/SignUpPage.js";

const routes: RouteObject[] = [
  { path: "/signin", element: <SignInPage /> },
  { path: "/signup", element: <SignUpPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/onboarding", element: <OnboardingPage /> },
      {
        path: "/",
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "portfolio", element: <PortfolioPage /> },
          { path: "signals", element: <AISignalsPage /> },
          { path: "scanner", element: <ScannerPage /> },
          { path: "leaderboard", element: <Leaderboard /> },
          { path: "paper", element: <PaperDashboard /> },
          { path: "live", element: <LiveDashboard /> },
          { path: "training", element: <TrainingCenterPage /> },
          { path: "dca", element: <DcaPage /> },
          { path: "alerts", element: <AlertsPage /> },
          { path: "health", element: <SystemHealth /> },
          { path: "keys", element: <ExchangeKeysPage /> },
          { path: "m/portfolio", element: <MobilePortfolioPage /> },
          {
            path: "settings",
            element: (
              <PlaceholderPage
                title="Settings"
                subtitle="Profile, security, 2FA, notifications, billing. Auth backend ready, UI built out in later phases."
                icon="gear"
                phase={3}
              />
            ),
          },
        ],
      },
    ],
  },
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
